<div class="surface-card border-round flex shadow-2">
    <div class="bg-blue-50 flex align-items-center justify-content-center py-3 px-5">
        <p-galleria [(value)]="images" [responsiveOptions]="responsiveOptions" [numVisible]="3" [containerStyle]="{maxWidth:'300px'}"> 
            <ng-template pTemplate="item" let-item>
                <img [src]="'assets/layout/images/facturar-facil-ecuador-white.svg'"  alt="{{appConfig.app.name }}" style="width: 100%; display: block;" />
            </ng-template>
            <ng-template pTemplate="thumbnail" let-item>
                <div class="grid grid-nogutter justify-content-center">
                    <img [src]="'assets/layout/images/facturar-facil-ecuador-white.svg'" alt="{{appConfig.app.name }}" style="width: 100%; display: block;"/>
                </div>
            </ng-template>
        </p-galleria>
    </div>
    <div class="py-3 px-5 flex flex-column align-items-start">
        <div class="text-900 font-medium mb-2 text-xl">Facturación electrónica</div>
        <p class="mt-0 mb-4 p-0 line-height-3">{{ plan.planName }} USD {{ plan.precio }}</p>
        <p class="mt-0 mb-4 p-0 line-height-2">Vigente desde: {{ plan.fechaInicio | date: 'yyyy/MM/dd' }}, hasta <strong>{{ plan.fechaFin | date: 'yyyy/MM/dd' }}</strong></p>
        <!--<button pButton pRipple label="Proceed" class="mt-auto"></button>-->
    </div>
    <div class="py-3 px-5 flex flex-column align-items-start">
        <div class="text-900 font-medium mb-2 text-xl">Firma electrónica</div>
        <p class="mt-0 mb-4 p-0 line-height-3">{{ plan.planTipoFirmaName == 'INDEFINIDO' ? 'Firma de otro proveedor' :  plan.planTipoFirmaName }}</p>
        <p class="mt-0 mb-4 p-0 line-height-2">Fecha de caducidad registrada: <strong>{{ plan.planTipoFirmaFechaFin | date: 'yyyy/MM/dd' }}</strong></p>
        <!--<button pButton pRipple label="Proceed" class="mt-auto"></button>-->
    </div>
</div>